module.exports = __webpack_public_path__ + "img/Bg.e03847ea.jpg";